import { BASE_INFORMATIZATION, SERVER_URL } from "@/config/constants";

const DEFAULT_LOGOUT_TIMEOUT_MS = 3000;

export async function requestSchoolUserLogout(
  token: string,
  timeoutMs = DEFAULT_LOGOUT_TIMEOUT_MS,
): Promise<void> {
  const normalized = token.trim();
  if (!normalized) return;

  const controller = new AbortController();
  const timer = window.setTimeout(() => controller.abort(), timeoutMs);

  try {
    // 必须走 SERVER_URL（API 网关）；相对路径会打到前端静态站 nginx，POST 返回 405
    await fetch(`${SERVER_URL}${BASE_INFORMATIZATION}/school/user/auth/logout`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${normalized}`,
      },
      signal: controller.signal,
    });
  } catch {
    // 退出 API 失败不阻断本地清态
  } finally {
    window.clearTimeout(timer);
  }
}
